import { Alpine } from "../../../../vendor/livewire/livewire/dist/livewire.esm";

export default () => ({
    enabled: Alpine.$persist(false).as("sensitive"),
    toggle() {
        this.enabled = !this.enabled;
    },
});
